<nav class="bg-black w-full z-20 top-0 left-0 border-b border-red-900">
	<div class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
	<a href="/" class="flex items-center">
		<img src="/assets/img/logo-light.png" class="h-16 mr-3" alt="Logo">
	</a>
	<div class="flex md:order-2">
		<a href="tel:+21650310331"><button type="button" class="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded text-sm px-4 py-2 text-center mr-3 md:mr-0 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">Appelez-nous</button></a>
		<button data-collapse-toggle="navbar-sticky" type="button" class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="navbar-sticky" aria-expanded="false">
		  <span class="sr-only">Open main menu</span>
		  <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
			  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h15M1 7h15M1 13h15"/>
		  </svg>
	  </button>
	</div>
	<div class="items-center justify-between hidden w-full md:flex md:w-auto md:order-1" id="navbar-sticky">
	  <ul class="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-black md:flex-row md:space-x-8 md:mt-0 md:border-0 md:bg-black ">
		<li>
		  <a href="/" class="block py-2 pl-3 pr-4 text-white bg-red-700 rounded md:bg-transparent md:text-white md:p-0 md:dark:text-red-500" aria-current="page">Accueil</a>
		</li>
		<li>
			<a href="https://maps.app.goo.gl/RNC6kMPmpz6gGU6S6?g_st=ic" class="block py-2 pl-3 pr-4 text-gray-400 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-red-700 md:p-0 md:dark:hover:text-red-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700">Boutique</a>
		  </li>
		<li>
		  <a href="/#/contact" class="block py-2 pl-3 pr-4 text-gray-400 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-red-700 md:p-0 md:dark:hover:text-red-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700">Contact</a>
		</li>
	  </ul>
	</div>
	</div>
</nav>

<main class="pattern-bg">
	<section class="dark">
		<div class="grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
			<div class="mr-auto place-self-center lg:col-span-7">
				<h1 class="max-w-2xl mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-5xl xl:text-6xl dark:text-white">L'élégance à louer avec La Bourgeoise</h1>
				<p class="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">Louez des robes exquises chez La Bourgeoise pour un mariage raffiné. Une collection exclusive pour briller avec élégance, en toute simplicité.</p>
				<a href="https://maps.app.goo.gl/RNC6kMPmpz6gGU6S6?g_st=ic" target="_blank" class="inline-flex items-center justify-center px-5 py-3 mr-3 text-base font-medium text-center text-white rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900 mb-3">
					Trouver notre boutique
					<svg class="w-5 h-5 ml-2 -mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
				</a>
				<a href="/#/contact" class="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-center text-gray-900 border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800">
					Contactez-nous
				</a> 
			</div>
			<div class="mt-6 lg:mt-0 lg:col-span-4 lg:flex relative mb-12">
				<img src="/assets/img/hero1.jpg" alt="Woman Mockup" class="w-48 sm:w-96 md:w-96 lg:w-96 rounded-lg z-10 hover:scale-105 duration-300 super-shadow-inverted drop-shadow-xl">
				<img src="/assets/img/hero2.jpg" alt="Woman Mockup 2" class="w-48 sm:w-96 md:w-96 lg:w-96 rounded-lg absolute z-0 ml-40 lg:ml-64 -mt-64 lg:mt-12 hover:scale-105 duration-300 super-shadow">
			</div>                
		</div>
	</section>

	<section class="dark pb-12">
		<h1 class="mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl dark:text-white text-center">Notre <span class="underline underline-offset-3 decoration-8 decoration-red-400 dark:decoration-red-600">Gallery:</span></h1>
		<p class="text-lg font-normal text-gray-500 lg:text-xl dark:text-gray-400 text-center mb-12">Une sélection de robes magnifiques et d'accessoires assortis pour briller avec élégance.</p>
		<div class="w-full flex justify-center items-center">
			<div class="grid grid-cols-2 md:grid-cols-3 gap-4 w-3/4">
				<div>
					<img class="h-48 max-w-96 lg:h-auto lg:max-w-full md:h-auto md:max-w-full sm:h-96 sm:max-w-96 object-cover rounded-lg hover:scale-105 duration-300" src="/assets/img/gallery/1.jpg" alt="La Bourgeoise Gallery">
				</div>
				<div>
					<img class="h-48 max-w-96 lg:h-auto lg:max-w-full md:h-auto md:max-w-full sm:h-96 sm:max-w-96 object-cover rounded-lg hover:scale-105 duration-300" src="/assets/img/gallery/2.jpg" alt="La Bourgeoise Gallery">
				</div>
				<div>
					<img class="h-48 max-w-96 lg:h-auto lg:max-w-full md:h-auto md:max-w-full sm:h-96 sm:max-w-96 object-cover rounded-lg hover:scale-105 duration-300" src="/assets/img/gallery/3.jpg" alt="La Bourgeoise Gallery">
				</div>
				<div>
					<img class="h-48 max-w-96 lg:h-auto lg:max-w-full md:h-auto md:max-w-full sm:h-96 sm:max-w-96 object-cover rounded-lg hover:scale-105 duration-300" src="/assets/img/gallery/4.jpg" alt="La Bourgeoise Gallery">
				</div>
				<div>
					<img class="h-48 max-w-96 lg:h-auto lg:max-w-full md:h-auto md:max-w-full sm:h-96 sm:max-w-96 object-cover rounded-lg hover:scale-105 duration-300" src="/assets/img/gallery/5.jpg" alt="La Bourgeoise Gallery">
				</div>
				<div>
					<img class="h-48 max-w-96 lg:h-auto lg:max-w-full md:h-auto md:max-w-full sm:h-96 sm:max-w-96 object-cover rounded-lg hover:scale-105 duration-300" src="/assets/img/gallery/6.jpg" alt="La Bourgeoise Gallery">
				</div>
				<div>
					<img class="h-48 max-w-96 lg:h-auto lg:max-w-full md:h-auto md:max-w-full sm:h-96 sm:max-w-96 object-cover rounded-lg hover:scale-105 duration-300" src="/assets/img/gallery/7.jpg" alt="La Bourgeoise Gallery">
				</div>
				<div>
					<img class="h-48 max-w-96 lg:h-auto lg:max-w-full md:h-auto md:max-w-full sm:h-96 sm:max-w-96 object-cover rounded-lg hover:scale-105 duration-300" src="/assets/img/gallery/8.jpg" alt="La Bourgeoise Gallery">
				</div>
				<div>
					<img class="h-48 max-w-96 lg:h-auto lg:max-w-full md:h-auto md:max-w-full sm:h-96 sm:max-w-96 object-cover rounded-lg hover:scale-105 duration-300" src="/assets/img/gallery/9.jpg" alt="La Bourgeoise Gallery">
				</div>
			</div>
		</div>
	</section>

	<section class="dark pb-12">
		<div class="max-w-screen-xl px-4 py-8 mx-auto text-center lg:py-16 lg:px-6">
			<figure class="max-w-screen-md mx-auto">
				<svg class="h-12 mx-auto mb-3 dark:text-gray-400" viewBox="0 0 24 27" fill="#fff" xmlns="http://www.w3.org/2000/svg">
					<path d="M14.017 18L14.017 10.609C14.017 4.905 17.748 1.039 23 0L23.995 2.151C21.563 3.068 20 5.789 20 8H24V18H14.017ZM0 18V10.609C0 4.905 3.748 1.038 9 0L9.996 2.151C7.563 3.068 6 5.789 6 8H9.983L9.983 18L0 18Z" fill="currentColor"/>
				</svg> 
				<blockquote>
					<p class="text-2xl font-medium text-gray-900 dark:text-white">"La Bourgeoise : qualité exceptionnelle, service client impeccable. Recommandé pour vos occasions spéciales !"</p>
				</blockquote>
				<figcaption class="flex items-center justify-center mt-6 space-x-3">
					<img class="w-6 h-6 rounded-full" src="/assets/img/default.jpg" alt="Review User">
					<div class="flex items-center divide-x-2 divide-gray-500 dark:divide-gray-700">
						<div class="pr-3 font-medium text-gray-900 dark:text-white">Kaouther Bouznes</div>
						<div class="pl-3 text-sm font-light text-gray-500 dark:text-gray-400">Client chez La Bourgeoise</div>
					</div>
				</figcaption>
			</figure>
		</div>
	</section>
</main>

<section class="dark bg-black">
	<footer class="bg-black shadow dark:bg-black border-t border-red-700">
		<div class="w-full max-w-screen-xl mx-auto p-4 md:py-8">
			<div class="sm:flex sm:items-center sm:justify-between">
				<a href="/" class="flex items-center mb-4 sm:mb-0">
					<img src="/assets/img/logo-light.png" class="h-16 mr-3" alt="Logo" />
				</a>
				<ul class="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
					<li>
						<a href="https://maps.app.goo.gl/RNC6kMPmpz6gGU6S6?g_st=ic" class="mr-4 hover:underline md:mr-6 ">Emplacement Boutique</a>
					</li>
					<li>
						<a href="/#/contact" class="mr-4 hover:underline md:mr-6">Contact</a>
					</li>
				</ul>
			</div>
			<hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
			<span class="block text-sm text-gray-500 sm:text-center dark:text-gray-400">© <a href="/" class="hover:underline">La Bourgeoise™</a>. Tous Droits Réservés.</span>
		</div>
	</footer>
</section>

<style>
    .super-shadow {
        box-shadow: 1px 1px 0px #ff0000,
                2px 2px 0px #ff0000,
                3px 3px 0px #ff0000,
                4px 4px 0px #ff0000,
                5px 5px 0px #ff0000,
                6px 6px 0px #ff0000;
    }

	.super-shadow-inverted {
        box-shadow: -1px 1px 0px #ff0000,
                -2px 2px 0px #ff0000,
                -3px 3px 0px #ff0000,
                -4px 4px 0px #ff0000,
                -5px 5px 0px #ff0000,
                -6px 6px 0px #ff0000;
    }

	.pattern-bg {
		background-color: #000000;
		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23ff0000' fill-opacity='0.095'%3E%3Cpath d='M0 38.59l2.83-2.83 1.41 1.41L1.41 40H0v-1.41zM0 1.4l2.83 2.83 1.41-1.41L1.41 0H0v1.41zM38.59 40l-2.83-2.83 1.41-1.41L40 38.59V40h-1.41zM40 1.41l-2.83 2.83-1.41-1.41L38.59 0H40v1.41zM20 18.6l2.83-2.83 1.41 1.41L21.41 20l2.83 2.83-1.41 1.41L20 21.41l-2.83 2.83-1.41-1.41L18.59 20l-2.83-2.83 1.41-1.41L20 18.59z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");	
	}
</style>
